import { registerItinerarySummaryVariant } from "./variants/itinerarySummary/registerItinerarySummaryVariant";
import { registerVehicleRealtimeVariant } from "./variants/vehicleRealtime/registerVehicleRealtimeVariant";

registerVehicleRealtimeVariant();
registerItinerarySummaryVariant();

export { default as DynamicIslandSlot } from "./DynamicIslandSlot";

export type { DynamicIslandSlotProps } from "./DynamicIslandSlot";

export { useDynamicIslandOrchestrator } from "./hooks/useDynamicIslandOrchestrator.hook";

export { useDynamicIslandFabGapPercent } from "./hooks/useDynamicIslandFabGapPercent.hook";

export type { DynamicIslandUpdateCamera } from "./hooks/useDynamicIslandOrchestrator.hook";

export type { DynamicIslandHostContext } from "./dynamicIsland.registry";

export type {
    DynamicIslandHorizontalScrollOptions,
    DynamicIslandVariantShellOptions,
} from "./dynamicIslandShell.types";

export { computeDynamicIslandOccupiedPx } from "./layout/dynamicIslandLayout.tools";

export type {
    DynamicIslandKind,
    DynamicIslandPayload,
    DynamicIslandItinerarySummaryPayload,
    DynamicIslandVehicleRealtimePayload,
} from "./dynamicIsland.types";

